import { createSelector } from '@reduxjs/toolkit';

import type { GlobalState } from '@/redux/store';

const stateSelector = (state: GlobalState) => state;
const imageSearchSlice = createSelector(stateSelector, (state) => state.imageSearch);

export const getImageSearchStatus = createSelector(imageSearchSlice, (slice) => slice.status);
export const getImageSearchResults = createSelector(imageSearchSlice, (slice) => slice.results);
export const getImageSearchError = createSelector(imageSearchSlice, (slice) => slice.error);
export const getImageSearchThumbnailUrl = createSelector(imageSearchSlice, (slice) => slice.thumbnailUrl);
